export default "__VITE_ASSET__D$sFlPzp__"